import { render, staticRenderFns } from "./POIDetail.vue?vue&type=template&id=6dccf0c8&"
import script from "./POIDetail.vue?vue&type=script&lang=js&"
export * from "./POIDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports